module.exports = __webpack_public_path__ + "img/tealium.c251c744.png";